import { styled } from '@mui/material/styles'
import { FC } from 'react'

const Loader = styled('div')(() => `
  height: 10px;
  aspect-ratio: 2.5;
  --_g: no-repeat radial-gradient(farthest-side,#3465C8 100%,#0000);
  background: var(--_g), var(--_g), var(--_g), var(--_g);
  background-size: 20% 50%;
  animation: l43 1s infinite linear;

  @keyframes l43 {
    0%      { background-position: calc(0*100%/3) 50%, calc(1*100%/3) 50%, calc(2*100%/3) 50%, calc(3*100%/3) 50%; }
    16.67% { background-position: calc(0*100%/3) 0,   calc(1*100%/3) 50%, calc(2*100%/3) 50%, calc(3*100%/3) 50%; }
    33.33% { background-position: calc(0*100%/3) 100%,calc(1*100%/3) 0,   calc(2*100%/3) 50%, calc(3*100%/3) 50%; }
    50%    { background-position: calc(0*100%/3) 50%, calc(1*100%/3) 100%,calc(2*100%/3) 0,   calc(3*100%/3) 50%; }
    66.67% { background-position: calc(0*100%/3) 50%, calc(1*100%/3) 50%, calc(2*100%/3) 100%,calc(3*100%/3) 0; }
    83.33% { background-position: calc(0*100%/3) 50%, calc(1*100%/3) 50%, calc(2*100%/3) 50%, calc(3*100%/3) 100%; }
    100%   { background-position: calc(0*100%/3) 50%, calc(1*100%/3) 50%, calc(2*100%/3) 50%, calc(3*100%/3) 50%; }
  }
`)

export const C1DotLoader: FC = () => <Loader data-testid="c1-dot-loader" />
